<template>
  <div>
    <div v-if="!question.isVoterEligible">
      <h1 class="headline">Skipping: {{ question.header }}</h1>
      <p>
        We're skipping this step because voting on this matter is limited to
        <b>{{ subgroupsFormatted }}.</b>
      </p>

      <p>Please click on the "Next" button to continue.</p>
    </div>
    <div v-else>
      <h1 class="headline">{{ question.header }}</h1>
      <span v-html="question.snippet"></span>
      <p v-if="bylawDownloadLink">
        <!-- Default link text -->
        <a target="_blank" :href="bylawDownloadLink">
          <!-- If custom link text has been provided -->
          <span v-if="downloadLinkText">{{ downloadLinkText }}</span>
          <!-- Default link text -->
          <span v-else>Click here for additional information</span>
        </a>
      </p>

      <div class="toggle-list mdl-shadow--2dp">
        <toggle-list-item
          v-if="!displayOptionToggle ? true : displayOptionToggle.yes.visible"
          value="yes"
          toggle-icon="check"
          :icon="displayIconsToggle ? 'thumb_up' : ''"
          :text="displayOptionToggle ? displayOptionToggle.yes.label : 'Yes'"
          :checked-status="vote.selection === 'yes'"
          toggle-class="toggle-content-action"
          @inputting="updateSelection"
        />

        <toggle-list-item
          v-if="!displayOptionToggle ? true : displayOptionToggle.no.visible"
          value="no"
          toggle-icon="check"
          :icon="displayIconsToggle ? 'thumb_down' : ''"
          :text="displayOptionToggle ? displayOptionToggle.no.label : 'No'"
          :checked-status="vote.selection === 'no'"
          toggle-class="toggle-content-action"
          @inputting="updateSelection"
        />

        <toggle-list-item
          v-if="
            !displayOptionToggle ? true : displayOptionToggle.abstain.visible
          "
          value="abstain"
          toggle-icon="check"
          :icon="displayIconsToggle ? 'block' : ''"
          :text="
            displayOptionToggle
              ? displayOptionToggle.abstain.label
              : 'Abstain from voting'
          "
          :checked-status="vote.selection === 'abstain'"
          toggle-class="toggle-content-action"
          @inputting="updateSelection"
        />

        <toggle-list-item
          v-if="
            !isProxyDisabled &&
              !preventProxyDeferrals &&
              (!displayOptionToggle ? true : displayOptionToggle.defer.visible)
          "
          value="defer"
          toggle-icon="check"
          :icon="displayIconsToggle ? 'how_to_vote' : ''"
          :text="
            displayOptionToggle
              ? displayOptionToggle.defer.label
              : 'Allow my proxy to choose'
          "
          :checked-status="vote.selection === 'defer'"
          toggle-class="toggle-content-action"
          @inputting="updateSelection"
        />
      </div>

      <transition name="slide-fade">
        <i v-if="isAbstain && isProxyDisabled">
          You choose not to vote on this matter.
        </i>
        <i v-else-if="isAbstain">
          You choose not to vote and your proxy shall not vote on this matter.
        </i>
        <i v-else-if="isDefer">
          You give authority to your proxy to vote in any manner, as you could
          do if you were personally present at the meeting.
        </i>
      </transition>
    </div>
    <div class="App-buttons">
      <question-button :is-disabled="isDisabled" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

import QuestionButton from '../QuestionsButton.vue';
import ToggleListItem from '../ToggleListItem.vue';

import {mapActions, mapGetters} from 'vuex';

import {subgroups} from '@/vuex/helpers.js';

export default {
  components: {
    QuestionButton,
    ToggleListItem
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    questionId: {
      type: [Number, String],
      required: true
    },
    meetingOptions: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters(['shortCode']),
    // Check the disabled state of the button
    isDisabled() {
      return this.vote.selection[0] === '' && this.question.isVoterEligible;
    },
    isAbstain() {
      return this.vote.selection === 'abstain';
    },
    isDefer() {
      return this.vote.selection === 'defer';
    },
    vote() {
      return this.question.vote;
    },
    icon() {
      return this.question.icon ? this.question.icon : 'gavel';
    },
    bylawDownloadLink() {
      return this.question.url ? this.question.url : '';
    },
    downloadLinkText() {
      return _.get(this.question, 'meta.options.downloadLinkText', null);
    },
    isProxyDisabled() {
      return _.get(this.meetingOptions, 'disable_proxy_holder', false);
    },
    displayOptionToggle() {
      return _.get(this.question, 'meta.options.toggles', false);
    },
    displayIconsToggle() {
      return !_.get(this.question, 'meta.options.hideIcons', false);
    },
    preventProxyDeferrals() {
      return _.get(this.meetingOptions, 'disable_proxy_deferrals', true);
    },
    subgroupsFormatted() {
      return subgroups(this.question);
    }
  },
  methods: {
    ...mapActions('questions', ['updateVote']),
    updateSelection(choice) {
      // update store
      this.updateVote({questionId: this.questionId, vote: choice});
    }
  },

  ready() {
    componentHandler.upgradeElement(this.$el);
  }
};
</script>

<style scoped>
.toggle-content {
  height: 50px;
}
</style>
